import React from 'react';
import moment from 'moment-timezone';
import { trainKindClass } from '../../data/trainKinds';

const TrainSchedule = ({ schedules, train, trainStatus }) => (
  <ul className="train-schedule">
    {schedules && schedules.map((schedule, index) => (
      <li
        key={index}
        className={`train-schedule-row ${throughClass(schedules, index, schedule.departureTime)}`}
      >
        <div className={`station-line ${trainKindClass(train.train_kind_id)} ${lastStationClass(schedules, index)}`}></div>
        <div className="station-info">
          <p className="name">{schedule.stationName}</p>
          <p className="time">{departureOrArrivalTime(schedules, index, schedule, trainStatus)}</p>
        </div>
      </li>
    ))}
  </ul>
);

const isLastStation = (schedules, schedulesIndex) => {
  if (schedules.length === schedulesIndex + 1 ) {
    return true;
  }

  return false;
}

const throughClass = (schedules, schedulesIndex, departureTime) => {
  if (isLastStation(schedules, schedulesIndex)) {
    return '';
  }

  if (departureTime === undefined) {
    return 'through';
  }

  return '';
};

const lastStationClass = (schedules, schedulesIndex) => {
  if (isLastStation(schedules, schedulesIndex)) {
    return 'last-station';
  }

  return '';
};

const departureOrArrivalTime = (schedules, schedulesIndex, schedule, trainStatus) => {
  if (trainStatus !== 0) {
    if (isLastStation(schedules, schedulesIndex)) {
      return '';
    }

    if (schedule.departureTime === undefined ) {
      return '通過';
    }

    return '';
  }

  if (isLastStation(schedules, schedulesIndex)) {
    return moment(schedule.arrivalTime, 'HH:mm').format('H:mm');
  }

  if (schedule.departureTime === undefined ) {
    return '通過';
  }

  return moment(schedule.departureTime, 'HH:mm').format('H:mm');
};

export default TrainSchedule;
